import styled from 'styled-components'
import { Button } from 'sutra/components/Button'
import { gray } from 'sutra/tokens/colors'

export const Caption = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: ${gray[600]};
  margin: 0 0 8px;
`

export const PickerRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 24px;
`

export const PickerField = styled.div`
  flex: 1 1 240px;
  min-width: 0;
`

export const Controls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`

export const AddButton = styled(Button)`
  flex-shrink: 0;
`

export const CountDivider = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${gray[600]};
  font-size: 14px;
  margin-bottom: 16px;

  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: ${gray[200]};
  }
`

export const SharesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const ShareRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const SkeletonRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const PersonInfo = styled.div`
  flex: 1;
  min-width: 0;
`

export const PersonName = styled.div`
  color: ${gray[900]};
  font-size: 14px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const PersonEmail = styled.div`
  color: ${gray[600]};
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const RoleText = styled.div`
  color: ${gray[900]};
  font-size: 14px;
  font-weight: 500;
  flex-shrink: 0;
`

export const MenuTrigger = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  height: 32px;
  padding: 0 12px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  flex-shrink: 0;
  border: 1px solid ${gray[300]};
  color: ${gray[900]};
  background: #fff;

  &::after {
    content: '';
    margin-left: 4px;
    border: 4px solid transparent;
    border-top-color: currentColor;
    border-bottom: 0;
  }

  &:hover {
    border-color: ${gray[400]};
  }
`

export const RemoveButton = styled.button`
  border: none;
  background: none;
  color: ${gray[600]};
  font-size: 13px;
  cursor: pointer;
  flex-shrink: 0;
  padding: 4px 8px;
  border-radius: 6px;

  &:hover {
    background: ${gray[100]};
  }
`
